<div class="flex flex-col items-center justify-center flex-1 p-5">
  <p-toast></p-toast>

  <h1 class="mb-4">{{ 'label.login' | translate }}</h1>
  <p-card class="w-full max-w-md">
    <form id="htmlLoginForm" action="" (submit)="onLogin()">
      <div class="mb-4">
        <p-floatlabel variant="on">
          <label for="email">{{ 'label.email' | translate }}</label>
          <input
            pInputText
            id="email"
            type="email"
            name="email"
            [(ngModel)]="email"
            [disabled]="loading"
            autocomplete="email"
            class="w-full"
        /></p-floatlabel>
      </div>
      <div class="mb-4">
        <p-floatlabel variant="on">
          <label for="password">{{ 'label.password' | translate }}</label>
          <input
            pInputText
            id="password"
            type="password"
            name="password"
            [(ngModel)]="password"
            [disabled]="loading"
            autocomplete="current-password"
            class="w-full"
        /></p-floatlabel>
      </div>
      <div class="mb-2">
        <button
          type="submit"
          [disabled]="loading"
          class="w-full"
          pButton
        >
          {{
            loading
              ? ('label.loading' | translate)
              : ('label.login' | translate)
          }}
        </button>
      </div>
      <a
        href="#"
        class="text-center text-sm text-gray-500"
        (click)="showForgotPassword($event)"
        >{{ 'label.forgotPassword' | translate }}</a
      >
    </form>
  </p-card>
</div>
